const STATUS_LABEL = { ordered: "On order", received: "Arrived", delivered: "Fitted / handed over" };
const STATUS_CLS = {
  ordered: "bg-amber-100 text-amber-900",
  received: "bg-sky-100 text-sky-900",
  delivered: "bg-emerald-100 text-emerald-900",
};

const days = (v) => (v === null || v === undefined ? "—" : `${v}d`);

export function PartStatusPill({ status }) {
  return (
    <span className={`px-1.5 py-0.5 text-[10px] font-mono uppercase ${STATUS_CLS[status] || ""}`}>
      {STATUS_LABEL[status] || status}
    </span>
  );
}

export function PartsCountCell({ r }) {
  return (
    <span className="font-mono text-xs whitespace-nowrap">
      {r.parts_total} · <span className="text-amber-700">{r.parts_on_order} on order</span> ·{" "}
      <span className="text-sky-700">{r.parts_received} arrived</span> ·{" "}
      <span className="text-emerald-700">{r.parts_fitted} fitted</span>
      {r.parts_overdue > 0 && <span className="ml-1 text-red-600 font-bold">· {r.parts_overdue} overdue</span>}
    </span>
  );
}

export default function PartsLinesTable({ lines, showAdvance, testPrefix }) {
  const heads = [showAdvance && "Advance", "Part", "Qty", "Order", "Status", "Ordered", "Expected", "Arrived", "Order to arrival", "Fitted", "Arrival to fitted"].filter(Boolean);
  return (
    <table className="w-full text-xs bg-white" data-testid={`${testPrefix}-lines`}>
      <thead className="border-b border-canvas-line">
        <tr>{heads.map((h) => <th key={h} className="px-2 py-1.5 font-mono text-[10px] uppercase text-left whitespace-nowrap text-ink-muted">{h}</th>)}</tr>
      </thead>
      <tbody>
        {lines.map((l) => (
          <tr key={l.line_id} className={`border-b border-canvas-line/40 ${l.overdue ? "bg-red-50" : ""}`} data-testid={`${testPrefix}-line-${l.part_code}`}>
            {showAdvance && <td className="px-2 py-1.5 font-mono">{l.advance_no}</td>}
            <td className="px-2 py-1.5"><span className="font-mono">{l.part_code}</span> <span className="text-ink-muted">{l.description}</span></td>
            <td className="px-2 py-1.5 font-mono">{l.qty}</td>
            <td className="px-2 py-1.5 font-mono whitespace-nowrap">{l.order_type || "—"} {l.order_number}</td>
            <td className="px-2 py-1.5"><PartStatusPill status={l.status} /></td>
            <td className="px-2 py-1.5 font-mono">{l.ordered_on || "—"}</td>
            <td className={`px-2 py-1.5 font-mono ${l.overdue ? "text-red-600 font-bold" : ""}`}>{l.expected_on || "—"}{l.overdue && " · OVERDUE"}</td>
            <td className="px-2 py-1.5 font-mono">{l.received_on || "—"}</td>
            <td className="px-2 py-1.5 font-mono">{l.status === "ordered" ? <span className="text-amber-700">{days(l.days_waiting)} waiting</span> : days(l.days_to_arrive)}</td>
            <td className="px-2 py-1.5 font-mono">{l.delivered_on || "—"}</td>
            <td className="px-2 py-1.5 font-mono">{days(l.days_to_fit)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
